<template>
    <label class="form-radio">
        <input v-model="model" type="radio" :value="option">

        <svg
            :class="{ active: active }"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <circle
                class="outer-circle"
                cx="12"
                cy="12"
                r="10.5" />

            <circle
                class="inner-circle"
                cx="5"
                cy="5"
                r="5"
                transform="translate(7 7)" />
        </svg>

        <span>
            <slot />
        </span>
    </label>

</template>

<script>
export default {
    props: {
        modelValue: {},
        option: {},
    },

    data() {
        return {
            model: null,
        };
    },

    computed: {
        active() {
            if (this.model === undefined) {
                return null;
            }

            if (Array.isArray(this.model)) {
                return this.model.includes(this.option);
            }

            return this.model;
        },
    },

    watch: {
        modelValue(value) {
            this.model = value;
        },

        model(value) {
            this.$emit('update:modelValue', value);
        },
    },

    created() {
        this.model = this.modelValue;
    },

    emits: ['update:modelValue'],
};
</script>
